<template>
  <div class="app-layout">
    <!-- 左侧边栏 -->
    <aside class="sidebar">
      <!-- 顶部 Logo -->
      <div class="sidebar-logo">
        <div class="logo-circle">佩</div>
        <div class="logo-text-group">
          <h1 class="logo-title">升前研</h1>
          <p class="logo-subtitle">项目管理</p>
        </div>
      </div>

      <!-- 导航菜单 -->
      <div class="sidebar-nav">
        <side-menu></side-menu>
      </div>

      <!-- 底部用户信息 -->
      <div class="sidebar-user">
        <div class="sidebar-user-inner">
          <div class="user-avatar-wrap">
            <img v-if="userInfo.avatar" :src="userInfo.avatar" class="user-avatar-img" />
            <i v-else class="el-icon-user"></i>
          </div>
          <div class="user-text">
            <el-dropdown @command="handleDropdown" trigger="click">
              <span class="user-dropdown-trigger">
                <span class="user-display-name">{{ userName }}</span>
                <i class="el-icon-arrow-down" style="font-size:11px;margin-left:4px;"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="change-password">修改密码</el-dropdown-item>
                <el-dropdown-item divided command="sign-out">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <p class="user-account">{{ userRole || userInfo.username || '' }}</p>
          </div>
        </div>
      </div>
    </aside>

    <!-- 右侧主体 -->
    <div class="main-section">
      <!-- 顶部 Header -->
      <header class="main-header">
        <div class="header-left-group">
          <h2 class="header-page-title">{{ pageTitle }}</h2>
        </div>
        <div class="header-right-group">
          <!-- 页面级操作由各页面自己提供 -->
        </div>
      </header>

      <!-- 内容区域 -->
      <div class="main-content">
        <el-scrollbar id="mainScroll" style="height: 100%">
          <div class="main-content-inner" id="container">
            <router-view />
          </div>
        </el-scrollbar>
      </div>
    </div>

    <!-- 技术支持对话框 -->
    <el-dialog
      :visible.sync="supportVisible"
      append-to-body
      :modal="false"
      width="300px"
    >
      <div class="title">技术支持</div>
      <el-form>
        <el-form-item label="邮箱：">lilin@personfg.com</el-form-item>
        <el-form-item label="电话：">010-84505518（9:00~18:00）</el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import SideMenu from './SideMenu'
import { signOut } from 'index/api'
import {
  UPDATE_USER_INFO
} from 'index/store/mutation-types'
import { checkGuide } from '@/constants/guide'
import guideSteps from '@/constants/guide-steps-index'

export default {
  name: 'Layout',

  components: {
    SideMenu
  },

  computed: {
    pageTitle() {
      const meta = this.$route.meta || {}
      return meta.title || '项目列表'
    },
    hideTag() {
      return this.$route.meta.hideTag
    },
    isXunjian() {
      return /\/xunjian/.test(this.$route.path)
    },
    userInfo() {
      return this.$store.getters.userInfo || {}
    },
    userName() {
      return this.userInfo.name || this.userInfo.username || '用户'
    },
    userRole() {
      const info = this.userInfo
      return (info.roles && info.roles.name) || ''
    }
  },

  data() {
    return {
      supportVisible: false
    }
  },

  mounted() {
    const startGuide = () => {
      setTimeout(() => this.tryGuide(), 1000)
    }
    if (!this.userName || this.userName === '用户') {
      this.$store.dispatch(UPDATE_USER_INFO).then(() => {
        startGuide()
      })
    } else {
      startGuide()
    }
  },

  methods: {
    tryGuide() {
      checkGuide(this.userInfo, 'projectList', guideSteps, (guideKey, version) => {
        var token = localStorage.getItem('ACCESS_TOKEN') || ''
        var baseUrl = process.env.VUE_APP_BASE_URL || ''
        fetch(baseUrl + '/jkd/home/user/markGuide', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
          body: JSON.stringify({ guideKey: guideKey, guideVersion: version })
        }).catch(function () {})
      }, this.$router)
    },
    handleDropdown(name) {
      switch (name) {
        case 'change-password':
          this.$router.push('/change-password')
          break
        case 'sign-out':
          signOut().then(() => {
            localStorage.removeItem('ACCESS_TOKEN')
            localStorage.removeItem('ccurrentId')
            window.location.href = '/'
          }).finally(() => {
            localStorage.removeItem('ACCESS_TOKEN')
            localStorage.removeItem('ccurrentId')
            window.location.href = '/'
          })
          break
      }
    }
  }
}
</script>

<style lang="scss">
/* ========================================================
   全局布局 — 完全匹配原型图
   注意：不使用 scoped，让样式能穿透到子组件
   ======================================================== */

/* ==================== 整体布局 ==================== */
.app-layout {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: #f8fafc;
}

/* ==================== 左侧边栏 ==================== */
.sidebar {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  background: #fff;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
}

/* Logo */
.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  flex-shrink: 0;
}

.logo-circle {
  width: 40px;
  height: 40px;
  background: #e53935;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 700;
  flex-shrink: 0;
}

.logo-text-group {
  min-width: 0;
}

.logo-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  line-height: 1.2;
}

.logo-subtitle {
  font-size: 11px;
  color: #94a3b8;
  margin: 3px 0 0;
  line-height: 1;
}

/* 导航 */
.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  min-height: 0; /* 关键：允许flex子项收缩 */
}

/* ===== 强制覆盖 treeMenu 样式 ===== */
.sidebar-nav .side-menu {
  padding-left: 0 !important;
  margin-top: 0 !important;
  background: transparent !important;
  width: 100% !important;
  padding: 0 16px !important;
  box-sizing: border-box;
}

.sidebar-nav .menuList {
  list-style: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.sidebar-nav .menuList .menu-item {
  padding: 2px 0 !important;
  line-height: 1 !important;
  font-weight: normal !important;
}

.sidebar-nav .menuList .menu-item__wrap {
  display: flex !important;
  align-items: center !important;
  padding: 10px 12px !important;
  border-radius: 8px !important;
  color: #475569 !important;
  font-size: 13px !important;
  transition: all 0.15s ease !important;
  cursor: pointer !important;
}

.sidebar-nav .menuList .menu-item__wrap:hover {
  background: #f1f5f9 !important;
  color: #0f172a !important;
}

.sidebar-nav .menuList .menu-item.active > .menu-item__wrap {
  background: rgba(20, 118, 255, 0.08) !important;
  color: #1476ff !important;
  font-weight: 500 !important;
}

.sidebar-nav .menuList .menu-icon {
  float: none !important;
  width: auto !important;
  font-size: 18px !important;
  margin-right: 12px !important;
  flex-shrink: 0;
}

.sidebar-nav .menuList .menu-name {
  margin-left: 0 !important;
  font-size: 13px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== 底部用户信息 ===== */
.sidebar-user {
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.sidebar-user-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
}

.user-avatar-wrap {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  color: #94a3b8;
  font-size: 18px;
}

.user-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-text {
  flex: 1;
  min-width: 0;
}

.user-dropdown-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-display-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px;
}

.user-account {
  font-size: 11px;
  color: #94a3b8;
  margin: 2px 0 0;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ==================== 右侧主体 ==================== */
.main-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

/* Header */
.main-header {
  height: 56px;
  min-height: 56px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.header-left-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-page-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  white-space: nowrap;
}

.header-right-group {
  display: flex;
  align-items: center;
}

/* 强制覆盖 TopNav 样式 */
.header-right-group .top-nav {
  height: auto !important;
  background: transparent !important;
  line-height: 1 !important;
  font-size: 13px !important;
}

.header-right-group .top-nav__content {
  display: none !important;
}

.header-right-group .top-nav__menu {
  margin-right: 0 !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
}

.header-right-group .top-nav__menu .headerImg {
  margin: 0 !important;
  font-size: 20px !important;
}

.header-right-group .top-nav__menu .avatar {
  width: 28px !important;
  height: 28px !important;
}

.header-right-group .top-nav__menu .userName {
  font-size: 13px !important;
  max-width: 80px !important;
  color: #475569;
}

.header-right-group .top-nav__menu span {
  float: none !important;
}

.header-right-group .top-nav__menu .el-dropdown-link {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 内容区域 */
.main-content {
  flex: 1;
  overflow: hidden;
  background: #f8fafc;
}

.main-content-inner {
  padding: 0;
  min-height: 100%;
}

.main-content .el-scrollbar__wrap {
  overflow-x: hidden;
}

/* 隐藏旧的元素 */
.main-header + .visited-tags,
.main-header + div[class*="visited"] {
  display: none !important;
}
</style>
